package com.hyperether.goodjob.scenes.user.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.Text
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun TeamItemWeb(
    text: String,
    isChecked: Boolean,
    onCheckedChange: (Boolean) -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(horizontal = 40.toScaleDp())
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = com.hyperether.goodjob.theme.Divider,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(vertical = 16.toScaleDp()),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Checkbox(
            modifier = Modifier
                .scale(1f)
                .pointerHoverIcon(PointerIcon.Hand),
            checked = isChecked,
            onCheckedChange = onCheckedChange,
            colors = CheckboxDefaults.colors(
                checkedColor = BlueApp,
                uncheckedColor = com.hyperether.goodjob.theme.Divider
            )
        )
        Spacer(modifier = Modifier.width(40.toScaleDp()))

        Text(
            text = text,
            modifier = Modifier.weight(1.25f),
            fontSize = 14.toScaleSp(),
            color = BlueApp,
            fontWeight = FontWeight.Bold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}
